import { render, staticRenderFns } from "./NotificationMessages.vue?vue&type=template&id=e464f730&"
import script from "./NotificationMessages.vue?vue&type=script&lang=js&"
export * from "./NotificationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports